import { createReducer, createAction } from "redux-act";
import { createSelector } from "reselect";

import { reducerRegistry } from "./reducerRegistry";
import { api } from "../evergis/api";

import { RootState } from "./reducers";
import { AppConfigState } from "../appConfig/types";

export const reducerName = "appConfig";

const initialState: AppConfigState = null;

export const getAppConfig = ({ appConfig }: RootState): AppConfigState => {
  return appConfig || ({} as AppConfigState);
};

export const getAppConfigModules = createSelector(getAppConfig, config => config?.modules || []);

export const getAppConfigShared = createSelector(getAppConfig, () => api.isShared);

export const getAppConfigPresentation = createSelector(getAppConfig, () => api.isPresentation);

export const setAppConfig = createAction<AppConfigState>("appConfig/setAppConfig");

export const reducer = createReducer({}, initialState).on(setAppConfig, (_, appConfig) => appConfig);

export const getSettingsProp =
  (key: keyof AppConfigState["settings"]) =>
  ({ appConfig }: RootState) =>
    appConfig &&
    (appConfig.settings === undefined || appConfig.settings[key] === undefined || appConfig.settings[key] === true);

reducerRegistry.register(reducerName, reducer);
